import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from 'react-cookie';
import {
    Paper,
    Button,
    Grid
} from '@material-ui/core';
import axios from 'axios';
import Common from '../Common';

const styles = () => ({
    displayFlex: {
        display: 'flex'
    },
    verticalSpace: {
        margin: '10px 100px 20px 150px',
    },
    searchButtonSpace: {
        margin: '10px 0px 10px 50px',
        width:200,
        height:50,
        fontSize:'20px'
    }
});

const CreateButton = withCookies((props) => {
    const {
        classes,
        cookies,
        categoryId,
        categoryName,
        address,
        nickName,
        setPreviewFlg,
        setNickName,
        nameObj,
        setLiffUrl,
        setEncodedAddres
    } = props;

    const postData = () => {
        let errAlert = '';
        if(categoryId === '') errAlert += `・${nameObj.KUBUN_NAME}を選択して下さい。`;
        if(address.trim() === ''){
            if(errAlert !== '') errAlert += '\n';
            errAlert += `・${nameObj.ADDRESS_NAME}を入力して下さい。`;
        }
        if(errAlert !== ''){
            window.alert(errAlert);
            return;
        }
        const token = cookies.get('token');
        const jichitaiToken = cookies.get('x-jichitai-token');
        const jichitaiId = cookies.get('x-jichitai-jichitaiid');
        axios.get(
            `${Common.apiServerUrl()}/api/qr`,
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'x-suppportcenter-token': token,
                    'x-jichitai-jichitaiid': jichitaiId,
                    'x-jichitai-token': jichitaiToken,
                },
                params: {
                    categoryId,
                    address
                },
            }
        )
        .then(Common.handleErrors)
        .then((res) => {
            if (res.success) {
                if(!res.created){
                    window.alert(`入力された${nameObj.ADDRESS_NAME}は登録されていません。`);
                }
                else if(res.exist){
                    const confirm = window.confirm(`既に${nameObj.KUBUN_NAME}と${nameObj.ADDRESS_NAME}が連携されており、\n${nameObj.USER_NAME}：${res.nickName}でQRコードが作成されています。\n\nQRコードを表示しますか。`);
                    if(confirm){
                        setLiffUrl(res.liff);
                        setPreviewFlg(true);
                        setNickName(res.nickName);
                        setEncodedAddres(res.encodedAddress);
                    }
                }
                else{
                    if(nickName.trim() === ''){
                        if(errAlert !== '') errAlert += '\n';
                        errAlert += `QRコードが未作成です。\n${nameObj.USER_NAME}を入力して下さい。`;
                    }
                    if(errAlert !== ''){
                        window.alert(errAlert);
                        return;
                    }
                    let alertMsg = `・${nameObj.KUBUN_NAME}：${categoryName[0].label}\n`;
                    alertMsg += `・${nameObj.ADDRESS_NAME}：${address}\n`;
                    alertMsg += `・${nameObj.USER_NAME}：${nickName}\n`;
                    alertMsg += 'この内容でQRコードを作成します。\nよろしいですか。\n';
                    const confirm = window.confirm(alertMsg);
                    if(confirm){
                        axios.post(
                            `${Common.apiServerUrl()}/api/qr`,
                            {
                                categoryId,
                                address,
                                nickName
                            },
                            {
                                headers: {
                                    Accept: 'application/json',
                                    'Content-Type': 'application/json',
                                    'x-suppportcenter-token': token,
                                    'x-jichitai-jichitaiid': jichitaiId,
                                    'x-jichitai-token': jichitaiToken,
                                },
                            }
                        )
                        .then(Common.handleErrors)
                        .then((response) => {
                            if (response.success) {
                                setLiffUrl(res.liff);
                                setPreviewFlg(true);
                                setEncodedAddres(res.encodedAddress);
                            } else {
                                window.alert(`code : [${response.type}]\nmessage : ${response.message}`);
                            }
                        })
                        .catch((err) => {
                            console.error('CreateQRButton.js postData:post err:' + err);
                        });
                    }
                }
            } else {
                window.alert(`code : [${res.type}]\nmessage : ${res.message}`);
            }
        })
        .catch((err) => {
            console.error('CreateQRButton.js postData:get err:' + err);
        });
    };

    return (
        <React.Fragment>
            <Grid>
                <div>
                    <div className={classes.displayFlex + ' ' + classes.verticalSpace}>
                        <Button color="primary" size="large" className={classes.searchButtonSpace} variant="contained" onClick={() => postData()}>発行・確認</Button>
                    </div>
                </div>
            </Grid>
        </React.Fragment>
    );
});

CreateButton.propTypes = {
    classes: PropTypes.object.isRequired,
    categoryId: PropTypes.string.isRequired,
    categoryName: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    nickName: PropTypes.string.isRequired,
    setPreviewFlg:PropTypes.func.isRequired,
    setLiffUrl:PropTypes.func.isRequired,
    setNickName: PropTypes.func.isRequired,
    setEncodedAddres: PropTypes.func.isRequired,
    cookies: PropTypes.object.isRequired,
    nameObj: PropTypes.object.isRequired,
};

export default withStyles(styles)(CreateButton);